import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Camera, CameraOff } from "lucide-react";

export default function QrScanner({ onScan, label = "مسح رمز QR بالكاميرا", manualHint = "أو أدخل رقم التصريح يدويًا" }) {
  const [on, setOn] = useState(false);
  const [err, setErr] = useState("");
  const ref = useRef(null);
  const cb = useRef(onScan);
  cb.current = onScan;

  useEffect(() => {
    if (!on) return undefined;
    const q = new Html5Qrcode("qr-reader");
    ref.current = q;
    let done = false;
    q.start({ facingMode: "environment" }, { fps: 10, qrbox: { width: 240, height: 240 } }, (text) => {
      if (done) return;
      done = true;
      q.stop().catch(() => {}).finally(() => setOn(false));
      cb.current(text);
    }, () => {}).catch(() => { setErr(`تعذر فتح الكاميرا. تحقق من السماح للمتصفح باستخدامها، ${manualHint}.`); setOn(false); });
    return () => { if (q.isScanning) q.stop().catch(() => {}); };
  }, [on, manualHint]);

  return (
    <div className="space-y-2">
      <button type="button" className={on ? "k-btn-outline w-full h-14 text-lg" : "k-btn-accent w-full h-14 text-lg"} onClick={() => { setErr(""); setOn(!on); }} data-testid="qr-scan-toggle">
        {on ? <><CameraOff className="w-6 h-6" /> إيقاف الكاميرا</> : <><Camera className="w-6 h-6" /> {label}</>}
      </button>
      <div id="qr-reader" className={on ? "rounded-xl overflow-hidden border-2 border-[#D97706]" : "hidden"} />
      {err && <div className="text-sm text-rose-700 font-bold" data-testid="qr-error">{err}</div>}
    </div>
  );
}
